Service = App.loadClass 'core::Angular/Service'

class exports.ChemicalsService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getAllChemicals: () =>
        # When the function is called by the Angular controller, hit the following route
        # (which will trigger a function in the Chemicals.php laravel controller)
        @http.post 'backend/admin/new-tools/chemicals/all-chemicals'
            # no parameters to pass, but we would show them here if we had some.

    actuallySaveChemicals: (chemicals) =>
        @http.post 'backend/admin/new-tools/chemicals/save-chemicals',
            chemicals: chemicals
    saveChemical: (chemical) =>
        @http.post 'backend/admin/new-tools/chemicals/save-chemical', chemical

